/***
* Add by hxzhu
* created:20190805
* 注:营销活动订单界面
*/
<template>
  <div>
    <div class="pg_body" v-if="ListActOrder.length > 0">
      <div v-for="(items,index) in ListActOrder" :key="index">
        <div class="Rows_one">
          <span style="float:left;">{{items.merName}}</span>
          <span v-if="items.paid==1" style="float:right;color:#F1BE36">已支付</span>
          <span v-else style="float:right;color:#F1BE36">未支付</span>
        </div>
        <div class="Rows_one">
          <span style="float:left;">订单号:{{items.orderId}}</span>
        </div>
        <div class="Rows_two">
          <img class="pic" :src="imageUrl+items.actPic" alt/>
          <div class="info">
            <div style="color:darkgrey;">{{items.actName}}</div>
            <div style="color:darkgrey;">商品价格:{{items.totalMoney}}元</div>
            <div style="color:darkgrey;">购买时间:{{items.orderTime}}</div>
          </div>
        </div>
        <div class="pg_fool">
          合计：
          <span>{{items.buyNum*items.totalMoney}}</span>元
        </div>
        <div class="order_btn" v-if="items.paid == 0">
          <button class="order-btn" @click="btnremove(items, index)">删除订单</button>
          <button class="order-btn" style="margin-left:10px;border: 1px solid rgb(243, 166, 35);color: rgb(243, 166, 35);"
                  @click="btnpay(items, index)">支付
          </button>
        </div>
        <div class="order_btn" v-else>
          <button class="order-btn" @click="consume(items, index)">消费</button>
        </div>
      </div>
    </div>
    <div class='null' v-else>
      <img class='pic' src="../../resource/img/pic_coupon_empty.png"/>
      <div>暂无内容</div>
    </div>
  </div>
</template>

<script>
var activityId
var uid
export default {
  name: 'MerTokerOrder',
  data () {
    return {
      ListActOrder: [],
      openid: '',
      imageUrl: sessionStorage.url,
    }
  },
  created () {
    let that = this
    activityId = that.$route.query.activityId
    uid = that.$route.query.uid
    if (that.$route.query.openid != null) {
      that.openid = that.$route.query.openid
    }
    if (that.$route.query.type != null && that.$route.query.type == 1) {
      this.$root.$children[0].pageData = 2
    }
    that.$axios.post(
        '/merchant/api/order/extend-order/list/user',
        that.$qs.stringify({activityId: activityId, uid: uid})
      ).then(response => {
        if (response.data != '') {
          that.ListActOrder = response.data.data
        }
      }).catch(function (error) {
        //请求失败处理
        console.log(error)
      })
  },
  methods: {
    btnpay: function (items, index) {
      var that = this
      that.$router.push({
        path: '/MerTokerPay',
        // name: "MerTokerPay",
        query: {
          orderInfo: JSON.stringify(that.ListActOrder[index]),
          openid: that.openid
        }
      })
    },
    btnremove: function (items, index) {
      var that = this
      that.$axios
        .post(
          '/merchant/api/order/extend-order/delete',
          that.$qs.stringify({
            id: items.id
          })
        )
        .then(response => {
          alert(response.data.msg)
          that.ListActOrder = response.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    consume: function (items, index) {
      let that = this
      that.$router.push({
        path: '/MerTokerOrderUse',
        query: {
          orderId: items.orderId,
          activityId: items.activityId,
          orderType: 0
        }
      })
    },
    // 返回上一层
    goback: function () {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
.pg_body {
  margin-top: 50px;
  padding: 0px 3vw;
}

.pg_fool {
  height: 5vh;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
}


.Rows_one {
  height: 5vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Rows_two {
  display: flex;
  flex-direction: row;
  width: 100vw;
  height: 13vh;
  margin-top: 10px;
  background: rgba(250, 250, 250, 1);
}

.Rows_two .pic {
  width: 90px;
  height: 90px;
  border-radius: 10px;
  margin-right: 16px;
  object-fit: cover;
}

.Rows_two .info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}


.order_btn {
  height: 5.5vh;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.order_btn .order-btn {
  height: 28px;
  line-height: 28px;
  border-radius: 23px;
  border: 1px solid rgba(155, 155, 155, 1);
  background-color: white;
  padding: 0 20px;
  outline: none;
}

.null {
  margin-top: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.null .pic {
  width: 200px;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/active/MerTokerOrder.vue